"use client";

import React from "react";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

interface RatingStarsProps {
  rating: number; // from 0 to 5
  reviewCount?: number | null;
}

const RatingStars: React.FC<RatingStarsProps> = ({ rating, reviewCount }) => {
  const stars = [];
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;

  for (let i = 0; i < fullStars; i++) {
    stars.push(<FaStar key={`full-${i}`} className="text-yellow-400" />);
  }

  if (hasHalfStar) {
    stars.push(<FaStarHalfAlt key="half" className="text-yellow-400" />);
  }

  while (stars.length < 5) {
    stars.push(
      <FaRegStar key={`empty-${stars.length}`} className="text-yellow-400" />
    );
  }

  return (
    <div className="flex items-center gap-1">
      {stars}
      {reviewCount !== undefined && (
        <span className="text-xs text-gray-500 ml-1">({reviewCount ?? 0})</span>
      )}
    </div>
  );
};

export default RatingStars;
